import { formatDatePeriods } from "../components/Reports/logic";
import { ActiveStatuses } from "./Statuses";

export type EnquiryFilterType = "Status" | "Ownership" | "SlaColour" | "HasAttachments" | "ReceivedOn" | "ExpireOn";

// One filter per type may be active; enquiries must match all of them.
export interface iEnquiryFilter {
    type: EnquiryFilterType;
    value: string;
    label: string;
}

export interface iEnquiryFilterGroup {
    heading: string;
    options: iEnquiryFilter[];
}

export const ReportingPeriods = ["Today", "Previous Day", "This Week", "Previous Week", "This Month", "Previous Month"];

export const EnquiryFilterGroups: iEnquiryFilterGroup[] = [
    {
        heading: "Status",
        options: ActiveStatuses.map(s => ({ type: "Status", value: s.ID.toString(), label: s.Name })),
    },
    {
        heading: "Ownership",
        options: [
            { type: "Ownership", value: "Owned", label: "Owned by me" },
            { type: "Ownership", value: "Unowned", label: "Unowned" },
        ],
    },
    {
        heading: "SLA Colour",
        options: [
            { type: "SlaColour", value: "Green", label: "Green" },
            { type: "SlaColour", value: "Amber", label: "Amber" },
            { type: "SlaColour", value: "Red", label: "Red" },
            { type: "SlaColour", value: "Purple", label: "Purple" },
        ],
    },
    {
        heading: "Attachments",
        options: [{ type: "HasAttachments", value: "true", label: "Has Attachments" }],
    },
    {
        heading: "Received On",
        options: ReportingPeriods.map(p => ({ type: "ReceivedOn", value: p, label: p })),
    },
    {
        heading: "Expire On",
        options: ReportingPeriods.map(p => ({ type: "ExpireOn", value: p, label: p })),
    },
];

export function getEnquiryFilterHeading(filter: iEnquiryFilter): string {
    return EnquiryFilterGroups.find(g => g.options.some(o => o.type === filter.type))?.heading ?? "";
}

export function getEnquiryFilterKey(filter: iEnquiryFilter): string {
    return filter.type + "-" + filter.value;
}

// Appends the active filters, at most one per type, to an enquiry list request. Date periods are resolved client side.
export function appendEnquiryFilterHeaders(headers: Headers, filters: iEnquiryFilter[] | undefined) {
    filters?.forEach(filter => {
        switch (filter.type) {
            case "Status":
                headers.append("filterStatus", filter.value);
                break;
            case "Ownership":
                headers.append("filterOwnership", filter.value);
                break;
            case "SlaColour":
                headers.append("filterSlaColour", filter.value);
                break;
            case "HasAttachments":
                headers.append("filterHasAttachments", "true");
                break;
            case "ReceivedOn":
            case "ExpireOn": {
                const prefix = filter.type === "ReceivedOn" ? "filterReceived" : "filterExpire";
                const { startDate, endDate } = formatDatePeriods(filter.value);
                headers.append(prefix + "From", startDate);
                headers.append(prefix + "To", endDate);
                break;
            }
        }
    });
}
